import { render, staticRenderFns } from "./VBudgetHalfForm.vue?vue&type=template&id=5f921045&"
import script from "./VBudgetHalfForm.vue?vue&type=script&lang=js&"
export * from "./VBudgetHalfForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports